"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBoard = initBoard;
exports.initStartingBoard = initStartingBoard;
var constants_1 = require("@/constants");
/**
 * Creates a board with checkers at the specified positions.
 *
 * @param whitePositions - Array of board indices where white checkers should be placed
 * @param blackPositions - Array of board indices where black checkers should be placed
 * @returns A board array with checkers placed at the specified positions
 */
function initBoard(whitePositions, blackPositions) {
    var board = Array(24)
        .fill(null)
        .map(function () { return ({ count: 0, player: null }); });
    // Place white checkers
    whitePositions.forEach(function (pos) {
        if (pos >= 0 && pos < 24) {
            if (board[pos].count === 0) {
                board[pos] = { count: 1, player: constants_1.PLAYER_WHITE };
            }
            else {
                board[pos].count++;
            }
        }
    });
    // Place black checkers
    blackPositions.forEach(function (pos) {
        if (pos >= 0 && pos < 24) {
            if (board[pos].count === 0) {
                board[pos] = { count: 1, player: constants_1.PLAYER_BLACK };
            }
            else {
                board[pos].count++;
            }
        }
    });
    return board;
}
/**
 * Creates a standard starting board for backgammon.
 *
 * @returns A board array in the standard starting position
 */
function initStartingBoard() {
    // Standard backgammon starting positions
    var blackPositions = [
        0,
        0, // 2 checkers on point 1
        11,
        11,
        11,
        11,
        11, // 5 checkers on point 12
        16,
        16,
        16, // 3 checkers on point 17
        18,
        18,
        18,
        18,
        18 // 5 checkers on point 19
    ];
    var whitePositions = [
        23,
        23, // 2 checkers on point 24
        12,
        12,
        12,
        12,
        12, // 5 checkers on point 13
        7,
        7,
        7, // 3 checkers on point 8
        5,
        5,
        5,
        5,
        5 // 5 checkers on point 6
    ];
    return initBoard(whitePositions, blackPositions);
}
//# sourceMappingURL=board.js.map